import "./Stylesheets/Contact.css"
import insta from "../../Components/Icons/Instagram.svg";
import linkin from "../../Components/Icons/LinkedIn.svg";
import axios from "axios";

import {useState} from "react";

export default function Contact(){


    // Backend URL
    const backend_url = process.env.REACT_APP_BACKEND_URL;


    const [message, setMessage] = useState("");

    // Create post function
    const handleSubmit = (e : React.FormEvent<HTMLFormElement>) => {
 
        e.preventDefault();

        const content = new FormData(e.currentTarget);

        const name = content.get("name");

        const email = content.get("email");

        const message = content.get("message");

        console.log(`sending payload ${name}, ${email}, ${message}`)
        axios.post(`${backend_url}/Login/SendEmail/`, {Name: name, Email: email, Message: message}, {withCredentials: true})
        .then((res) => {
            console.log(res.status)
            if (res.status == 200) {
                setMessage("Email Sent!");
            }
        })
        .catch((err) => {
            console.log("Something went wrong" + err);
            setMessage("Something went wrong! Try again later...");
        })


    }
    return(
        <div className={"main-contact-content-container"}>

            <div className={"contact-info-container"}>
                <h2>Contact Me!</h2>
                <hr></hr>
                <form onSubmit={handleSubmit}>
                    <div className={"form-input-container"}>
                        <label htmlFor="name">Name</label>
                        <input required type="text" id="name" name="name" placeholder="Your name.." />
                    </div>
                  
                    <div className={"form-input-container"}>
                        <label htmlFor="email">Email</label>
                        <input required type="text" id="email" name="email" placeholder="Your email.." />
                    </div>

                    <div className={"form-input-container"}>
                        <label htmlFor="message">Message</label>
                        <textarea required   id="message" name="message" placeholder="Write something.." style={{height:"200px"}}></textarea>
                    </div>
                    <input type="submit" value="Submit"></input>
                </form>
                {message}
                <br></br>
                <br></br>
                <hr></hr>
                <br></br>

                
            </div>

        </div>
    )
}